import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from './firebase';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    try {
      await sendPasswordResetEmail(auth, email.trim(), {
        url: `${window.location.origin}/login`,
        handleCodeInApp: false,
      });
      setMessage('Check your email for a reset link. If it does not arrive, verify the address and try again.');
    } catch (err) {
      console.error(err);
      setError('Could not send reset email. Check the address or try again later.');
    }
  };

  return (
    <div className="login-page">
      <h1>Reset password</h1>
      <p style={{ maxWidth: '400px', margin: '0 auto 1rem', lineHeight: 1.5 }}>
        Enter the email for your parent account. We will send a link to reset your password.
      </p>
      <form onSubmit={handleSubmit} style={{ maxWidth: '400px', margin: '0 auto' }}>
        <div className="form-group">
          <label htmlFor="reset-email">Email</label>
          <input
            id="reset-email"
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            placeholder="Your account email"
          />
        </div>
        {message && (
          <p style={{ color: '#B4975A', marginTop: '12px', lineHeight: 1.5 }} role="status">
            {message}
          </p>
        )}
        {error && <p style={{ color: 'red', marginTop: '12px' }}>{error}</p>}
        <button type="submit" className="btn btn-teal mt-4">
          Send reset link
        </button>
        <p style={{ marginTop: '20px' }}>
          <Link to="/login">Back to login</Link>
        </p>
      </form>
    </div>
  );
};

export default ResetPassword;
